import { render } from "./NAttachmentsList.vue?vue&type=template&id=56c9ad80&ts=true"
import script from "./NAttachmentsList.vue?vue&type=script&lang=ts"
export * from "./NAttachmentsList.vue?vue&type=script&lang=ts"

import "./NAttachmentsList.vue?vue&type=style&index=0&id=56c9ad80&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__